import React from "react"
import { Badge, Divider, Space, Typography } from "antd"
import { NavLink } from "react-router-dom"
import { ASAPOrder, OrderAndPrefix } from "../Orders/Helpers/OrderAndPrefix"
import { formatNumberWithSpaces } from "../Orders/Helpers/FormatNumbersWithSpaces"
import "./ActiveOrderBar.css"
import useLiveElapsed from "../../hooks/useLiveElapsed"

const { Text } = Typography

export default function ActiveOrderBar({
  order,
  machine,
  showProjectedMeters = true,
  className = "active-box",
  extraItems = null,
  rightSlot = null,
}) {
  const linkBase = order ? `/${String(machine || "").toLowerCase()}/orders/${order.id}` : "#"

  const running = !!order?.[`currentlyInUseFor${machine}`]
  const startedAt = order?.[`jobStartedAt${machine}`] // Firestore Timestamp
  const baseSec = Number(order?.[`jobTotalSec${machine}`] ?? 0)

  const { formatted } = useLiveElapsed(startedAt, baseSec, running)

  return (
    <div className={className}>
      {order ? (
        <Space split={<Divider type="vertical" />} align="center" wrap>
          <Badge color="red" text="Currently in use" />

          <NavLink to={linkBase} style={{ fontWeight: 500 }}>
            {ASAPOrder(order)}
            {OrderAndPrefix(order)}
          </NavLink>

          <Text ellipsis={{ tooltip: order?.client?.client }}>{order?.client?.client}</Text>
          <Text ellipsis={{ tooltip: order?.selectedProduct?.product?.productName }}>
            {order?.selectedProduct?.product?.productName}
          </Text>
          <Text>{formatNumberWithSpaces(order?.labelCount)}</Text>
          <Text>{order?.selectedProduct?.labelWidth}</Text>
          <Text>{order?.selectedProduct?.labelHeight}</Text>
          <Text>
            {order?.readRollWidth ? order?.rollWidth : order?.selectedProduct?.formatWidth}
          </Text>
          {showProjectedMeters && <Text>{order?.projectedMeters ?? 0} m</Text>}
          <Text ellipsis={{ tooltip: order?.selectedProduct?.material }}>
            {order?.selectedProduct?.material}
          </Text>
          <Text type={running ? "danger" : "secondary"}>
            {running ? `Running: ${formatted}` : `Total: ${formatted}`}
          </Text>
        </Space>
      ) : (
        <Text type="secondary">No order is currently active</Text>
      )}
    </div>
  )
}
